import { TrashIcon } from '@phosphor-icons/react';
import { T, useGT } from 'gt-react';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { WorkbookRowMenu } from './WorkbookRowMenu';

/**
 * Remove one data Source from the Workbook. Shown on hover or keyboard focus of
 * its row, and while open, laid over the row's end so names keep their width. Worksheets reading it are kept, and say what to repoint.
 */
export function WorkbookSourceMenu({
  name,
  disabled,
  onRemove,
}: {
  name: string;
  disabled: boolean;
  onRemove: () => void;
}) {
  const gt = useGT();
  const optionsLabel = gt('{name} options', {
    context: 'workbook source menu',
    name,
  });
  return (
    <WorkbookRowMenu label={optionsLabel} disabled={disabled}>
      <DropdownMenuItem variant="destructive" onClick={onRemove}>
        <TrashIcon />
        <T context="workbook source menu">Remove</T>
      </DropdownMenuItem>
    </WorkbookRowMenu>
  );
}
